<script>

    export let icon = "save"
    export let type = "submit"
    export let loading = false
    export let text = 'Guardar'
    /** ID del `<form>` asociado (útil si el botón no es descendiente del form en el DOM). */
    export let form = undefined

</script>

<button { type } {form} class="button is-primary" class:is-loading={loading}>
    <span class="icon"><i class="fas fa-{icon}"></i></span>
    <span>{ text }</span>
</button>